import React from 'react'

import isNil from 'lodash/isNil'

import { ITableData } from 'components/layout/table/tableData'
import { formatNumber, formatUnit } from 'utils'

interface ITableResultData extends ITableData {
  highlight?: boolean
  big?: boolean
}

const TableResultData: React.FC<ITableResultData> = (props) => {
  const { name, col, text, highlight, leftAlign, big, unit } = props

  const getText = () => {
    if (!isNil(unit) && !isNil(text)) {
      return `${formatNumber(String(text), unit)} ${formatUnit(unit)}`
    }
    return text
  }

  return (
    <div
      key={name}
      className={`w-${col}/12 flex items-center ${leftAlign ? 'text-left' : 'text-right'}`}
    >
      {text !== undefined && (
        <p
          className={`w-full whitespace-no-wrap ${
            highlight ? 'text-brand-primary' : 'text-black'
          } font-500 ${big ? 'text-15 tracking-0.12' : 'text-13 tracking-0.1'}`}
        >
          {getText()}
        </p>
      )}
    </div>
  )
}

export default TableResultData
